<p-panel header="Process Is Almost Complete">
  <div class="font-semibold mb-6">
    Please make sure that all available documentation required for review is
    attached to the request.
  </div>
  <div class="mb-6">
    <p class="font-semibold">Accepted Documents:</p>
    <ul class="list-disc pl-10 my-4">
      <li class="mb-2">Face Sheet (Demographic Info)</li>
      <li class="mb-2">Physician's Order</li>
      <li class="mb-2">Clinical Documentation</li>
      <li class="mb-2">Other (as applicable for skilled care)</li>
    </ul>
  </div>

  <div>
    <p class="font-semibold">
      If you do not have any clinical documentation to attach, please select
      'I do not have any clinical documents' below.
    </p>
    <p-message class="mt-4" severity="warn" icon="pi pi-exclamation-triangle" style="width: fit-content">
      Clinical documents are required to qualify request for auto approval (adjudication).
    </p-message>
  </div>

  <div class="field-required mt-4">
    Do you have any Clinical documents?
    <div class="field mt-4">
      <div class="flex items-center">
        <p-radio-button
          inputId="hasClinicalDocuments_yes"
          [value]="true"
          [(ngModel)]="hasClinicalDocuments"
          [disabled]="documents?.length > 0"
          (change)="onChangeHasClinicalDocumentsField()"
        />
        <label for="hasClinicalDocuments_yes" class="ml-2">Yes</label>
      </div>
      <div class="flex items-center mt-2">
        <p-radio-button
          inputId="hasClinicalDocuments_no"
          [value]="false"
          [(ngModel)]="hasClinicalDocuments"
          [disabled]="documents?.length > 0"
          (change)="onChangeHasClinicalDocumentsField()"
        />
        <label for="hasClinicalDocuments_no" class="ml-2">No</label>
      </div>
    </div>
  </div>

  <div *ngIf="hasClinicalDocuments && isPacCommercial">
    90-day Health Plan Transition:
    <div class="field mt-4">
      <div class="p-field-checkbox-container p-field-checkbox">
        <p-checkbox
          binary="true"
          inputId="previousCarrierAuthorizationDocumentsField"
          data-test-id="previousCarrierAuthorizationDocuments"
          [(ngModel)]="hasPreviousCarrierDocuments"
          (change)="onChangeHasPreviousCarrierAuthorizationDocuments()"
        ></p-checkbox>
        <label for="previousCarrierAuthorizationDocumentsField">
          I have Previous Carrier Authorization documents.
        </label>
      </div>
    </div>
  </div>

  <div class="col-span-12">
    <p>
      You can upload up to 4 files with a total size of 20,480 KB. If needed, you can upload additional files from the
      Authorization Details view by clicking the Upload Documents button under the Documents menu on the left side.
    </p>
  </div>
  <p-panel header="Upload the file you would like to attach:">
    <div class="relative">
      <upload-document-pacim
        [disableComponent]="!hasClinicalDocuments"
        [documents]="documents"
        (uploadedNewFile)="loadFiles($event)"
      ></upload-document-pacim>
    </div>
  </p-panel>
</p-panel>
<div class="flex justify-between pt-6">
  <div>
    <button
      pButton
      severity="danger"
      aria-label="Cancel Create Authorization"
      label="Cancel"
      icon="pi pi-times"
      type="button"
      data-test-id="cancel-request-button"
      (click)="onCancel()"
    ></button>
  </div>
  <div>
    <button
      pButton
      aria-label="Back Step to Clinical Information"
      label="Back"
      icon="pi pi-arrow-left"
      class="p-button-secondary mr-2"
      type="button"
      data-test-id="back-step-button"
      (click)="onClickBack()"
    ></button>
    <button
      pButton
      aria-label="Next Step to Preview"
      label="Next"
      icon="pi pi-arrow-right"
      iconPos="right"
      type="button"
      data-test-id="next-step-button"
      [disabled]="hasClinicalDocuments && !documents?.length"
      (click)="onSubmit()"
    ></button>
  </div>
</div>
